document.addEventListener('DOMContentLoaded', () => {

  if (document.querySelectorAll('.favoriteIcon').length === 0) {
    return
  }
  const favoriteIcons = document.querySelectorAll('.favoriteIcon')
  favoriteIcons.forEach((favoriteIcon) => {
    favoriteIcon.addEventListener('click', function(event) {
      event.preventDefault()
      const currentStatus = this.getAttribute('data-goods-action-favorite')
      let newStatus = currentStatus === 'unregistered' ? 'registered' : 'unregistered'
      this.setAttribute('data-goods-action-favorite', newStatus)
    })
  })
})